<div class="app-page">
    <router-outlet></router-outlet>
    <app-hotjar></app-hotjar>
</div>